import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.667 13.3H5.333a2 2 0 0 1-2-2V4.633a.667.667 0 1 0-1.333 0V11.3a3.333 3.333 0 0 0 3.333 3.333h5.334a.667.667 0 0 0 0-1.333m-4-4.667a.667.667 0 0 0 .666.667h3.334a.667.667 0 0 0 0-1.333H7.333a.667.667 0 0 0-.666.666M14 5.927a1 1 0 0 0-.04-.18v-.06a.7.7 0 0 0-.127-.187l-4-4a.7.7 0 0 0-.186-.127.2.2 0 0 0-.06 0 .6.6 0 0 0-.22-.073h-2.7a2 2 0 0 0-2 2v6.667a2 2 0 0 0 2 2H12a2 2 0 0 0 2-2v-4.04m-4-2.354L11.727 5.3h-1.06A.667.667 0 0 1 10 4.633zm2.667 6.394a.667.667 0 0 1-.667.666H6.667A.667.667 0 0 1 6 9.967V3.3a.667.667 0 0 1 .667-.667h2v2a2 2 0 0 0 .12.667H7.333a.667.667 0 0 0 0 1.333h5.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })